import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import visionImage from '../assets/images/vision.jpg'; // replace with actual path
import heroBg from '../assets/images/HeroBanner.png';
import '../styles/Facot.css';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const AIOTAPaymentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const membershipData = location.state?.membershipData;
  console.log('Membership Data:', membershipData);

  const handleDummyPayment = async () => {
    try {
      const token = localStorage.getItem('token'); 
      console.log('Processing dummy payment...');
      const apiBaseUrl = process.env.REACT_APP_BASEURL ;

      if (!membershipData?.email || !membershipData?.name) {
        alert('Missing user data. Please register again.');
        navigate('/');
        return;
      }
      
console.log('API Base URL:', apiBaseUrl);
      const response = await axios.post(`${apiBaseUrl}/payment-complete`, {
        email: membershipData.email,
        account_holder_name: membershipData.name,
      },
    {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    );
      console.log('Payment Response:', response.data);
      console.log('Payment successful, redirecting to login page...');
      // Navigate to login page on success
      navigate('/member-login');
    } catch (error) {
      console.error('Error creating login:', error);
      alert('Failed to create login, try again.');
    }
  };

  const handleMemberLogin = () => {
    navigate('/member-login');
  };

  const handleEdcclogin = () => { 
    navigate('/edcc-login');
  };

  return (
    <>
      <section className="hero-fixed">
        <div className="hero-content">
          <h1>All India Occupational Therapists' Association</h1>
          
          <div className="hero-buttons">
            <button className="glass-button" onClick={handleMemberLogin}>
              Member Login
            </button>            
            <button className="glass-button" onClick={handleEdcclogin}>Erganomic Certificate login</button>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content">
        <div className="content-container">
          <section className="main-section">
            <Container>
              {/* Add payment UI elements here if needed */}
            </Container>
          </section>
          <section className="next-button-section">
            <Container>
              <Row className="justify-content-center">
                <Col xs="auto">
                  <Button variant="primary" size="lg" className="next-button" onClick={handleDummyPayment}>
                    Next
                  </Button>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default AIOTAPaymentPage;